export default "__VITE_ASSET__BMEiKOE0__"